import { ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { finalize, timer } from 'rxjs';
import { BrokerService } from 'src/app/core/services/broker.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';
import { LoadService } from 'src/app/core/services/load.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { CONECTAS_ROUTE_MAP } from '../bc-connect/interfaces/conectas-route-map';

declare var $: any;

@Component({
	selector: 'app-confirm-telephone',
	templateUrl: './confirm-telephone.component.html',
	styleUrls: ['./confirm-telephone.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false
})
export class ConfirmTelephoneComponent implements OnInit {

	// public step = 1;
	public haveMinHeight = true;
	public code = '';
	public timerCode: number = 90;
	public seconds: number = 0;
	public minutes: number = 0;
	public source = timer(0, 1000);
	public clock: any;
	public isSendCode: boolean = false;
	public errorCode = false;
	public loadSendCode = false;
	public errorSendCode = false;
	public errorValidateCode = false;
	public tryValidateCode = 0;
	public waitCode = 0;
	public loadApplyOffer = false;
	public stateValue: any;
	// public errorApply = false;

	constructor(public load: LoadService, public sesion: SesionService, public offerService: OfferService, private dataLayerService: DataLayersService, public broker: BrokerService, public utilities: UtilitiesService, private cookieService: CookieService, public router: Router, private cdr: ChangeDetectorRef) { }

	ngOnInit(): void {
	}

	private get isDoctorPeso(): boolean {
		return CONECTAS_ROUTE_MAP[this.offerService.offerSelected?.company?.id] === 'doctorpeso';
	}

	ngAfterViewChecked() {
		let isMobile = window.innerWidth <= 768;
		if (this.sesion.stepConfirmTelephone == 4 && isMobile) {
			this.haveMinHeight = false;
		} else {
			this.haveMinHeight = true;
		}

	}

	nextNumCode(event: Event, del: boolean = false) {
		let element = (event.target as HTMLInputElement);
		if (!del) {
			if ((event as InputEvent).inputType == "deleteContentBackward") {
				element.value = '';
				let previous = element.previousElementSibling as HTMLElement;
				previous.focus();
			} else {
				let next = element.nextElementSibling as HTMLInputElement;
				next.value = '';
				if (element.value == '') {
					let previous = element.previousElementSibling as HTMLElement;
					previous.focus();
				} else {
					next.focus();
				}
			}
		} else {
			if ((event as KeyboardEvent).key == "Backspace" && element.value == '') {
				let previous = element.previousElementSibling as HTMLElement;
				previous.focus();
			}
		}
	}

	isValidCode() {
		let valid = false;
		document.querySelectorAll(".code-cel > input").forEach((ele: Element) => {
			if ((ele as HTMLInputElement).value == '') {
				valid = false;
				return false;
			} else {
				valid = true;
				return true;
			}
		});
		return valid;
	}

	sendCode(retry: boolean = false) {
		this.loadSendCode = true;
		this.errorSendCode = false;
		this.broker.createValidation(this.sesion.userPhone).pipe(
			finalize(() => {
				this.loadSendCode = false;
				this.cdr.detectChanges();
			})
		).subscribe({
			next: (res: any) => {
				if (res.message == 'Codigo OTP enviado!') {
					if (!retry) {
						this.nextStep();
						this.tryValidateCode = 0;
						this.errorCode = false;
						let numbers = document.querySelectorAll(".code-cel > input");
						numbers.forEach((element: Element) => {
							(element as HTMLInputElement).classList.remove("error-input");
						});
					}
				} else if (res.message == 'Numero de intentos superado') {
					if (this.sesion.confirmTelephoneConecta) {
						if (this.isDoctorPeso) {
							this.errorSendCode = true;
							return;
						}
						this.closeModalConfirm();
						this.load.openBcConecta();
						return;
					}
					this.sesion.semiValid = true;
					this.nextStep(3);
				}
				this.startTimer();
			},
			error: (err: any) => {
				this.errorSendCode = true;
				if (this.sesion.confirmTelephoneConecta) {
					if (this.isDoctorPeso) {
						return;
					}
					this.closeModalConfirm();
					this.load.openBcConecta();
					return;
				}
				this.sesion.semiValid = true;
				this.nextStep(3);
			}
		});
	}

	validateCode() {
		let code = '';
		document.querySelectorAll(".code-cel > input").forEach((ele: Element) => {
			code += (ele as HTMLInputElement).value;
		});
		this.tryValidateCode++;
		if (this.isValidCode()) {
			this.loadSendCode = true;
			this.errorValidateCode = false;
			this.errorCode = false;
			let numbers = document.querySelectorAll(".code-cel > input");
			numbers.forEach((element: Element) => {
				(element as HTMLInputElement).classList.remove("error-input");
			});
			this.broker.validateCode(code).pipe(
				finalize(() => {
					this.loadSendCode = false;
					this.cdr.detectChanges();
				})
			).subscribe({
				next: (res: any) => {
					if (res.message == 'Codigo OTP valido!') {
						const phoneValidation = this.sesion.ecsInfo?.params?.[3];
						if (phoneValidation) {
							phoneValidation.value = true;
						}
						if (this.isDoctorPeso) {
							this.sesion.doctorPesoPhoneValidated = true;
						}
						this.nextStep();
					} else {
						if (this.tryValidateCode >= 2) {
							if (this.sesion.confirmTelephoneConecta) {
								if (this.isDoctorPeso) {
									this.errorCode = true;
									return;
								}
								this.closeModalConfirm();
								this.load.openBcConecta();
								return;
							}
							this.sesion.semiValid = true;
							this.nextStep(3);
						} else {
							this.errorCode = true;
							let numbers = document.querySelectorAll(".code-cel > input");
							numbers.forEach((element: Element) => {
								(element as HTMLInputElement).classList.add("error-input");
							});
						}
					}
				},
				error: (err: any) => {
					this.errorValidateCode = true;
					if (this.sesion.confirmTelephoneConecta) {
						if (this.isDoctorPeso) {
							this.errorCode = true;
							return;
						}
						this.closeModalConfirm();
						this.load.openBcConecta();
						return;
					}
					if (this.tryValidateCode >= 2) {
						this.sesion.semiValid = true;
						this.nextStep(3);
					}
					this.errorCode = true;
					let numbers = document.querySelectorAll(".code-cel > input");
					numbers.forEach((element: Element) => {
						(element as HTMLInputElement).classList.add("error-input");
					});
				}
			});
		}
	}

	nextStep(step: number = 0) {
		if (step == 0) {
			this.sesion.stepConfirmTelephone++;
		} else {
			this.sesion.stepConfirmTelephone = step;
		}
		if (step == 1) {
			this.sesion.semiValid = false;
		}

		if (this.sesion.stepConfirmTelephone == 3 && this.sesion.confirmTelephoneConecta) {
			// Cerrar el modal de confirmación de teléfono
			this.closeModalConfirm();
			this.offerService.validateSoftFilters(this.isDoctorPeso);
			return;
		}

		if (this.sesion.stepConfirmTelephone == 3 && !this.offerService.hasSoftFilter) {
			this.sesion.stepConfirmTelephone = 4;
		}

		if (this.sesion.stepConfirmTelephone == 4 && !this.sesion.confirmTelephoneConecta) {

		}
	}

	showDate(end: any, now: any) {
		let distance = end - now;
		if (distance >= 0) {
			let _second = 1000;
			let _minute = _second * 60;
			this.seconds = Math.floor((distance % _minute) / _second);
			this.minutes = Math.floor((distance / _minute));
		} else {
			this.isSendCode = false;
			if (this.waitCode == 2) {
				this.sesion.semiValid = true;
				this.nextStep(3);
			}
			this.clock.unsubscribe();
		}
	}

	startTimer() {
		this.waitCode++;
		this.isSendCode = true;
		let end = new Date();
		if (this.clock != undefined) {
			this.clock.unsubscribe();
		}
		end.setSeconds(end.getSeconds() + this.timerCode);
		this.clock = this.source.subscribe(t => {
			let now = new Date();
			this.showDate(end, now);
		});
	}

	// Pestaña del aliado que se abre en el clic de "Continuar con la aplicación" (ver openAllyTab).
	private allyTab: Window | null = null;

	finalStep() {
		this.openAllyTab();
		this.sendAppply();
	}

	/**
	 * La URL del aliado se conoce hasta que responde el servicio de aplicar, cuando el navegador ya puede no
	 * considerar el clic como gesto del usuario y bloquear window.open. Por eso la pestaña se abre aquí, en el
	 * clic, y se le asigna la URL en redirectToAlly(). Si el navegador no la abre, redirectToAlly() conserva
	 * el comportamiento anterior (abrir el aliado en la misma pestaña).
	 */
	private openAllyTab(): void {
		this.allyTab = window.open('', '_blank');
		if (!this.allyTab) {
			return;
		}

		// La pestaña se navegará a un sitio externo: sin referencia a esta ventana.
		this.allyTab.opener = null;
		this.allyTab.document.title = 'Buscacrédito';
		this.allyTab.document.body.style.cssText = 'font-family: Roboto, Arial, sans-serif; padding: 24px; color: #333;';
		this.allyTab.document.body.textContent = 'Estamos gestionando tu solicitud...';
	}

	/** Abre la URL del aliado en la pestaña nueva preparada en el clic. */
	private redirectToAlly(url: string): void {
		const tab = this.allyTab;
		this.allyTab = null;

		if (tab && !tab.closed) {
			tab.location.href = url;
		} else if (!window.open(url, '_blank')) {
			window.location.href = url;
		}
	}

	/** Cierra la pestaña preparada cuando no hay URL del aliado a la cual redirigir (error o sin URL). */
	private discardAllyTab(): void {
		this.allyTab?.close();
		this.allyTab = null;
	}

	closeModalConfirm() {
		this.tryValidateCode = 0;
		this.offerService.errorApply = false;
		this.sesion.semiValid = false;
		this.sesion.confirmTelephoneConecta = false;
		this.load.close("#confirmationModalV2", true);
		this.offerService.errorPreselecta = false;
		this.offerService.clearOfferlocalStorage();
	}

	sendAppply() {
		let companyId = this.offerService.offerSelected.company.id;
		let offerId = this.offerService.offerSelected.offerId;
		let sourceOfTraffic = '';
		let campaignOfTraffic = '';
		let mediumOfTraffic = '';
		if ((Object.keys(this.utilities.utmParams).length > 0)) {
			for (const key in this.utilities.utmParams) {
				if (key.toLowerCase() == 'utm_source') {
					sourceOfTraffic = this.utilities.utmParams[key]
				}
				if (key.toLowerCase() == 'utm_medium') {
					mediumOfTraffic = this.utilities.utmParams[key]
				}
				if (key.toLowerCase() == 'utm_campaign') {
					campaignOfTraffic = this.utilities.utmParams[key]
				}
			}
		}
		let dataOferta = {
			idSession: this.sesion.sesionCookie,
			companyId: companyId,
			offerId: offerId,
			sourceOfTraffic: sourceOfTraffic,
			campaignOfTraffic: campaignOfTraffic,
			mediumOfTraffic: mediumOfTraffic
		}
		this.load.enableButtons = "none";
		this.load.openMicro('estamos gestionando tu solicitud');
		this.loadApplyOffer = true;
		this.offerService.errorApply = false
		this.broker.aplicarOferta(dataOferta).subscribe((resultado: any) => {
			if (resultado.orderNumber) {
				let offerAux = this.offerService.offersList.find((ele: any) => ele.company.id == this.offerService.offerSelected.company.id && ele.offerId == this.offerService.offerSelected.offerId);
				if (!offerAux) {
					this.discardAllyTab();
					return;
				}

				offerAux.preselecta.orderNumber = resultado.orderNumber;
				offerAux.preselecta.date = resultado.applyDate;
				offerAux.preselecta.urlRedirect = resultado.applyDetail.urlRedirect;
				//  Oferta especial Davivivenda. 							
				if (dataOferta.companyId == "860034313") {
					let dataOfertaDav = {
						idSession: this.sesion.sesionCookie,
						userAgent: "",
						idDevice: ""
					}
					this.broker.aplicarOfertaDav(dataOfertaDav).subscribe((resultado: any) => {
						if (resultado.body.includes("http")) {
							// GA4 - confirm_application
							this.dataLayerService.dl_eventoGA4_confirm_application(localStorage.getItem('productName'), offerId, localStorage.getItem('companyName'), 'Actualizar y Continuar');
							this.redirectToAlly(encodeURI(resultado.body));
						} else {
							this.discardAllyTab();
							this.router.navigate(['/error']);
						}
						if (resultado.statusCodeValue == 400) {
							this.discardAllyTab();
							this.load.open('#load-modal', '¡Error de aplicación!', 'No fue posible aplicar a esta oferta, te redirigiremos a otras ofertas para ti.', false, undefined);
							this.dataLayerService.dl_eventoGA4_confirm_application(localStorage.getItem('productName'), offerId, localStorage.getItem('companyName'), 'Actualización fallida');
							this.load.errorService();
						}
					}, () => this.discardAllyTab());
					this.load.closePopUp('NoBtn');
					this.load.enableButtons = "block";
					this.load.closeMicro();
					this.closeModalConfirm();
				} else {
					this.offerService.offerSelected.isApplied = true;
					let urlRedirect = resultado.applyDetail.urlRedirect;
					const urlEncriptedData = resultado.applyDetail.urlEncriptedData;
					// GA4 - confirm_application
					this.dataLayerService.dl_eventoGA4_confirm_application(localStorage.getItem('productName'), offerId, localStorage.getItem('companyName'), 'Actualizar y Continuar');
					if (urlRedirect != "" || urlRedirect != undefined) {
						if (this.offerService.offerSelected.settings.conecta) {
							if (resultado.responseConecta.status) {
								urlRedirect = resultado.responseConecta.detail.urlRedirect;
							} else {
								urlRedirect = '';
								offerAux.preselecta = {};
								this.load.errorService();
								this.dataLayerService.dl_eventoGA4_confirm_application(localStorage.getItem('productName'), offerId, localStorage.getItem('companyName'), 'Actualización fallida');
							}
						}
						// Solo para aliado Credissimo
						if (dataOferta.companyId == "901146443") {
							this.redirectToAlly(urlRedirect + '?bon=' + resultado.orderNumber);
						}
						// Para todos
						else {
							if (resultado.encryptedInfo != '') {
								if (this.utilities.hasQueryString(urlRedirect)) {
									urlRedirect = urlRedirect + '&lead=' + encodeURIComponent(resultado.encryptedInfo);
								}
								else {
									urlRedirect = urlRedirect + '?lead=' + encodeURIComponent(resultado.encryptedInfo);
								}
							}
							if (urlRedirect != "") {
								offerAux.preselecta.urlRedirect = urlRedirect;
								this.redirectToAlly(urlRedirect);
							}
						}
					}
					if (urlRedirect != "") {
						this.load.closePopUp('NoBtn');
						this.load.enableButtons = "block";
						this.load.closeMicro();
						this.closeModalConfirm();
					} else {
						this.discardAllyTab();
					}
				}
			} else {
				this.discardAllyTab();
				this.offerService.errorApply = true;
				this.sesion.semiValid = false;
				this.load.errorService();
				this.dataLayerService.dl_eventoGA4_confirm_application(localStorage.getItem('productName'), offerId, localStorage.getItem('companyName'), 'Actualización fallida');
			}
			this.loadApplyOffer = false;
		}, error => {
			this.discardAllyTab();
			this.offerService.errorApply = true;
			this.sesion.semiValid = false;
			this.loadApplyOffer = false;
			this.load.errorService();
			this.dataLayerService.dl_eventoGA4_confirm_application(localStorage.getItem('productName'), offerId, localStorage.getItem('companyName'), 'Actualización fallida');
		});
	}

	resultFilters(event: boolean) {
		if (event) {
			this.tryValidateCode = 0;
			this.offerService.errorApply = false;
			this.sesion.semiValid = false;
			this.sesion.confirmTelephoneConecta = false;
			this.offerService.errorPreselecta = false;
			this.offerService.clearOfferlocalStorage();

			const $confirmModal = $('#confirmationModalV2');
			const openNoOfertasModal = () => {
				this.load.typeNoOffers = 2;
				this.load.open('#noOfertasModal', '', '', false, undefined);
			};

			if ($confirmModal.hasClass('show') || $confirmModal.hasClass('in')) {
				$confirmModal.one('hidden.bs.modal', () => {
					openNoOfertasModal();
				});
				$confirmModal.modal('hide');
			} else {
				openNoOfertasModal();
			}
		} else {
			this.nextStep();
		}
	}
}